"use client";

import {CanonicalAnalyticsEventName, mapCanonicalEventToGtmPayloads} from "./analytics.events";
import {AnalyticsServiceClass} from "./analytics.service";
import type {
    InquiryFormOpenPayload,
    InquiryFormSubmitBookingSnapshot,
    InquiryFormSubmitPayload,
    InquiryFormValidationErrorPayload,
} from "./analytics.types";

export class InquiryFormAnalyticsClass extends AnalyticsServiceClass {
    trackOpen(payload: InquiryFormOpenPayload): void {
        try {
            this.trackCanonicalEvent({name: CanonicalAnalyticsEventName.InquiryFormOpened, properties: payload});
        } catch (err) {
            console.warn("[InquiryFormAnalytics] trackOpen failed:", err);
        }
    }

    trackSubmit(payload: InquiryFormSubmitPayload): void {
        try {
            for (const gtmPayload of mapCanonicalEventToGtmPayloads({name: CanonicalAnalyticsEventName.InquirySubmitted, properties: payload})) {
                this.push(gtmPayload);
            }
        } catch (err) {
            console.warn("[InquiryFormAnalytics] trackSubmit failed:", err);
        }
    }

    trackValidationError(payload: InquiryFormValidationErrorPayload): void {
        try {
            if (!payload.fields.trim()) return;
            this.trackCanonicalEvent({name: CanonicalAnalyticsEventName.InquiryValidationFailed, properties: payload});
        } catch (err) {
            console.warn("[InquiryFormAnalytics] trackValidationError failed:", err);
        }
    }

    trackSubmitFromBooking(unitId: string, booking: InquiryFormSubmitBookingSnapshot | null, success: true): void;
    trackSubmitFromBooking(unitId: string, booking: InquiryFormSubmitBookingSnapshot | null, success: false, errorCode: string): void;
    trackSubmitFromBooking(unitId: string, booking: InquiryFormSubmitBookingSnapshot | null, success: boolean, errorCode?: string): void {
        const info = booking;

        if (success) {
            if (!info?.checkIn || !info?.checkOut) {
                return;
            }

            this.trackSubmit({
                success: true,
                unit_id: unitId,
                check_in: info.checkIn,
                check_out: info.checkOut,
                adults: info.adults,
                children: info.children,
                pets: info.pets,
            });
            return;
        }

        this.trackSubmit({
            success: false,
            unit_id: unitId,
            check_in: info?.checkIn ?? null,
            check_out: info?.checkOut ?? null,
            adults: info?.adults ?? 0,
            children: info?.children ?? 0,
            pets: info?.pets ?? 0,
            error_code: errorCode ?? "unknown",
        });
    }
}

export type InquiryFormAnalyticsInstance = InquiryFormAnalyticsClass;

export function InquiryFormAnalytics(): InquiryFormAnalyticsInstance {
    return new InquiryFormAnalyticsClass();
}
